import { render, staticRenderFns } from "./OverlayFrosted.vue?vue&type=template&id=2f43a5d6&"
import script from "./OverlayFrosted.vue?vue&type=script&lang=js&"
export * from "./OverlayFrosted.vue?vue&type=script&lang=js&"
import style0 from "./OverlayFrosted.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports